import React, { useState, useEffect, useCallback } from 'react';
import { HiArrowRight } from 'react-icons/hi';

const slides = [
  {
    image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1920&q=80',
    tag: 'NAINA & KSC New Town',
    subtitle: "At the Nexus of Mumbai's $30 Billion Infrastructure Boom",
  },
  {
    image: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1920&q=80',
    tag: 'Navi Mumbai International Airport',
    subtitle: 'Mega infrastructure driving real estate growth',
  },
  {
    image: 'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=1920&q=80',
    tag: 'MahaMumbai 3.0',
    subtitle: 'The golden opportunity for strategic land investment',
  },
  {
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1920&q=80',
    tag: 'Plot Your Future',
    subtitle: 'High appreciation potential with clear titles',
  },
];

const SLIDE_DURATION = 5500;

const HeroCarousel = () => {
  const [current, setCurrent] = useState(0);
  const [progress, setProgress] = useState(0);
  const [formData, setFormData] = useState({ name: '', phone: '', email: '', project: '' });
  const [submitted, setSubmitted] = useState(false);
  const [textAnim, setTextAnim] = useState(true);

  const next = useCallback(() => {
    setTextAnim(false);
    setTimeout(() => setTextAnim(true), 50);
    setCurrent((p) => (p + 1) % slides.length);
    setProgress(0);
  }, []);

  const goTo = (i) => {
    setTextAnim(false);
    setTimeout(() => setTextAnim(true), 50);
    setCurrent(i);
    setProgress(0);
  };

  useEffect(() => {
    const t = setInterval(next, SLIDE_DURATION);
    return () => clearInterval(t);
  }, [next]);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((p) => Math.min(p + (100 / (SLIDE_DURATION / 30)), 100));
    }, 30);
    return () => clearInterval(interval);
  }, [current]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
    setFormData({ name: '', phone: '', email: '', project: '' });
  };

  return (
    <section id="home" className="relative w-full overflow-hidden" style={{ height: '100dvh', minHeight: '700px' }}>
      {/* Background Slides */}
      {slides.map((slide, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-all duration-[1200ms] ${
            i === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          <div
            className="absolute inset-0 bg-cover bg-center will-change-transform"
            style={{
              backgroundImage: `url(${slide.image})`,
              transform: i === current ? 'scale(1.08)' : 'scale(1)',
              transition: 'transform 12s ease-out',
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
        </div>
      ))}

      {/* Center Content */}
      <div className="relative z-20 h-full flex flex-col items-center justify-center text-center px-4 lg:pr-[370px]">
        <div className={`transition-all duration-700 max-w-4xl ${textAnim ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>

          <h1 className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-heading text-white mb-4 leading-[1.05] mt-12">
            Prime Investment
            <br />
            <span className="gradient-text italic">Plots</span> in <br/> Mumbai 3.0
          </h1>

          <p className="text-white/80 text-xs sm:text-sm tracking-[0.1em] max-w-xl mx-auto mb-10 font-light leading-relaxed">
            {slides[current].subtitle}
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <button onClick={() => window.dispatchEvent(new Event('openContactModal'))} className="inline-flex items-center gap-2.5 bg-white text-dark-800 rounded-full px-8 py-3.5 text-[12px] font-semibold tracking-wider uppercase hover:bg-accent-50 hover:shadow-xl transition-all duration-500 group">
              Book Free Consultation
              <HiArrowRight className="text-sm group-hover:translate-x-1 transition-transform" />
            </button>
            <a href="/Brochure.pdf" download className="inline-flex items-center gap-2 border border-white/25 text-white rounded-full px-8 py-3.5 text-[12px] font-medium tracking-wider uppercase hover:bg-white/10 transition-all duration-500">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
              Download Brochure
            </a>
          </div>

          {/* Logo chips */}
          <div className="flex items-center gap-3 sm:gap-5 flex-wrap justify-center mt-10">
            {[
              { src: '/assets/CIDCO.jpg', alt: 'CIDCO' },
              { src: '/assets/MMRDA.jpg', alt: 'MMRDA' },
            ].map((logo, i) => (
              <div key={i} className="bg-white rounded-xl px-5 py-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.35)]">
                <img src={logo.src} alt={logo.alt} className="h-10 sm:h-11 w-auto object-contain" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Slide indicators — vertical right side on desktop */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 lg:bottom-auto lg:top-1/2 lg:-translate-y-1/2 lg:left-auto lg:right-8 z-30 flex lg:flex-col items-center gap-2.5">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className="relative"
          >
            <div className={`transition-all duration-500 rounded-full overflow-hidden ${
              i === current ? 'w-8 h-2 lg:w-2 lg:h-8' : 'w-2 h-2'
            } ${i === current ? 'bg-white/20' : 'bg-white/25 hover:bg-white/50'}`}>
              {i === current && (
                <div
                  className="absolute inset-y-0 left-0 lg:inset-y-auto lg:inset-x-0 lg:bottom-0 bg-accent-400 rounded-full"
                  style={{
                    width: typeof window !== 'undefined' && window.innerWidth >= 1024 ? '100%' : `${progress}%`,
                    height: typeof window !== 'undefined' && window.innerWidth >= 1024 ? `${progress}%` : '100%',
                  }}
                />
              )}
            </div>
          </button>
        ))}
      </div>

      {/* Floating enquiry card — offset bottom-right on large screens */}
      <div className="hidden lg:block absolute z-20 bottom-12 right-8 xl:right-16 w-[340px]">
        <div className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.15)] p-6 border border-white/50">
          <p className="font-heading text-dark-800 text-base mb-1">Free Consultation</p>
          <p className="text-[11px] text-dark-300 font-light mb-4">Get expert guidance on plot investment</p>

          {submitted ? (
            <div className="text-center py-6">
              <div className="w-12 h-12 bg-primary-50 rounded-xl flex items-center justify-center mx-auto mb-3">
                <svg className="w-6 h-6 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <p className="font-heading text-dark-700">Thank You!</p>
              <p className="text-xs text-dark-400 mt-1 font-light">We'll contact you shortly.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-3">
              <input type="text" placeholder="Your Name *" required value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="w-full px-4 py-2.5 bg-gray-50 border border-gray-100 rounded-xl text-sm outline-none focus:border-primary-400 focus:bg-white transition-all" />
              <input type="tel" placeholder="Phone Number *" required value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                className="w-full px-4 py-2.5 bg-gray-50 border border-gray-100 rounded-xl text-sm outline-none focus:border-primary-400 focus:bg-white transition-all" />
              <select value={formData.project}
                onChange={(e) => setFormData({ ...formData, project: e.target.value })}
                className="w-full px-4 py-2.5 bg-gray-50 border border-gray-100 rounded-xl text-sm text-dark-400 outline-none focus:border-primary-400 focus:bg-white transition-all">
                <option value="">Area of Interest</option>
                <option>NAINA Plots</option>
                <option>KSC New Town Plots</option>
                <option>Near NMIA Airport</option>
                <option>MTHL Corridor</option>
              </select>
              <button type="submit" className="w-full bg-primary-600 hover:bg-primary-700 text-white rounded-xl py-3 text-[11px] font-semibold tracking-wider uppercase transition-all duration-300 flex items-center justify-center gap-2">
                Get Consultation <HiArrowRight className="text-xs" />
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default HeroCarousel;
